<template>
  <span
    v-w-tooltip="{ content: $t('ai_assistant.beta_label_tooltip') }"
    class="h-5 rounded border border-p-purple-30 px-2 py-0 text-xs font-semibold uppercase leading-5 tracking-wide text-p-purple-60"
  >
    {{ $t('ai_assistant.beta_label_text') }}
  </span>
</template>

<script setup lang="ts">
defineOptions({
  name: 'BetaLabel',
});
</script>
